module.exports = __webpack_public_path__ + "img/placeholder4.ff48d33f.jpg";